import React from "react";
import PropTypes from "prop-types";
import {SvgIcon} from "@mui/material";

const NewMaestroSessionIcon = ({fontSize}) => (
  <SvgIcon viewBox="0 0 24 24" id="new-maestro-session-icon" fontSize={fontSize}>
    {/* Robot body (SmartToyOutlined) scaled down to make room for + */}
    <g transform="translate(0, 2) scale(0.85)">
      { }
      <path d="M20 9V7c0-1.1-.9-2-2-2h-3c0-1.66-1.34-3-3-3S9 3.34 9 5H6c-1.1 0-2 .9-2 2v2c-1.66 0-3 1.34-3 3s1.34 3 3 3v4c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4c1.66 0 3-1.34 3-3s-1.34-3-3-3m-2 10H6V7h12zm-9-6c-.83 0-1.5-.67-1.5-1.5S8.17 10 9 10s1.5.67 1.5 1.5S9.83 13 9 13m7.5-1.5c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5 1.5.67 1.5 1.5M8 15h8v2H8z" />
    </g>
    {/* Plus sign overlay (top-right) */}
    <path d="M19 1h2v2h2v2h-2v2h-2V5h-2V3h2z" />
  </SvgIcon>
);

NewMaestroSessionIcon.propTypes = {
  fontSize: PropTypes.string,
};

export default NewMaestroSessionIcon;
